module.exports = __webpack_public_path__ + "media/images/device-patch1-26d1214e.png";